import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Highlander extends Bloc {

	constructor (src, ctx) {

		super("highlander", src, ctx);
		this.f = (src, ins) => {
			const cards = src.master.run.deck.filter(card => card.status !== "disabled" && !card.card.locked);
			return [new Set(cards.map(card => card.card.key)).size === cards.length];
		};
		this.types = [];
	}
}
